import { ReactNode } from 'react';

import * as Panel from './Panel';

function articleForTitle(title: string) {
  return title.match(/^(a|e|i|o|u|h)/i) ? 'an' : 'a';
}

type AddPlanPanelProps = {
  title: string;
  description: ReactNode;
  destinations: Panel.Destination[];
  footerIcons?: Panel.FooterIcon[];
  footerDescription?: ReactNode;
};
function AddPlanPanel({
  title,
  description,
  destinations,
  footerIcons,
  footerDescription,
}: AddPlanPanelProps) {
  const to = {
    pathname: `destinations/contact-success/${title.toLowerCase()}`,
  };

  return (
    <Panel.Root>
      <Panel.Header>
        <Panel.HeaderContent>
          <Panel.Title>
            Add {articleForTitle(title)} {title} plan to your Clearbit account
          </Panel.Title>
          <Panel.Subtitle>{description}</Panel.Subtitle>
        </Panel.HeaderContent>
        <Panel.CTA href={to}> Contact success team</Panel.CTA>
      </Panel.Header>
      <Panel.Separator />
      <Panel.Body>
        <Panel.Destinations destinations={destinations} />
      </Panel.Body>
      <Panel.Footer description={footerDescription} icons={footerIcons} />
    </Panel.Root>
  );
}

export default AddPlanPanel;
